import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { VideoPlayer } from '@tvg/fuse/video';
import '@splidejs/splide/dist/css/splide.min.css';
import styles from './ImageCarouselStyles.module.css';

type DivProps = React.HTMLAttributes<HTMLDivElement>;
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
type SpanProps = React.HTMLAttributes<HTMLSpanElement>;

export function OuterContainer({ className, ...props }: DivProps) {
  return <div className={[styles.outerContainer, className].filter(Boolean).join(' ')} {...props} />;
}

export function InnerContainer({ className, ...props }: DivProps) {
  return <div className={[styles.innerContainer, className].filter(Boolean).join(' ')} {...props} />;
}

type SplideProps = React.ComponentPropsWithoutRef<typeof Splide>;
export const MainCarousel = React.forwardRef<Splide, SplideProps>(({ className, ...props }, ref) => (
  <Splide ref={ref} className={[styles.MainCarousel, className].filter(Boolean).join(' ')} {...props} />
));
MainCarousel.displayName = 'MainCarousel';

export function ThumbnailCarouselContainer({ className, ...props }: DivProps) {
  return <div className={className} {...props} />;
}

export const ThumbnailCarousel = React.forwardRef<Splide, SplideProps>(({ className, ...props }, ref) => (
  <Splide ref={ref} className={[styles.thumbnailCarousel, className].filter(Boolean).join(' ')} {...props} />
));
ThumbnailCarousel.displayName = 'ThumbnailCarousel';

type SlideProps = React.ComponentPropsWithoutRef<typeof SplideSlide>;
export function Slide({ className, ...props }: SlideProps) {
  return <SplideSlide className={[styles.slide, className].filter(Boolean).join(' ')} {...props} />;
}

export function ArrowsContainer({ className, ...props }: DivProps) {
  return <div className={[styles.arrowsContainer, className].filter(Boolean).join(' ')} {...props} />;
}

export function PreviousArrow({ className, type, ...props }: ButtonProps) {
  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      className={[styles.arrow, styles.previousArrow, className].filter(Boolean).join(' ')}
      {...props}
    />
  );
}

export function NextArrow({ className, type, ...props }: ButtonProps) {
  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      className={[styles.arrow, styles.nextArrow, className].filter(Boolean).join(' ')}
      {...props}
    />
  );
}

export function PlayOverlay({ className, ...props }: SpanProps) {
  return <span className={[styles.playOverlay, className].filter(Boolean).join(' ')} {...props} />;
}

type VideoPlayerProps = React.ComponentPropsWithoutRef<typeof VideoPlayer>;
export function StyledVideoPlayer({ className, playsInline, controls, ...props }: VideoPlayerProps) {
  return (
    <VideoPlayer
      className={[styles.videoPlayer, className].filter(Boolean).join(' ')}
      playsInline={playsInline ?? true}
      controls={controls ?? true}
      {...props}
    />
  );
}
